

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const GETPDFSBYAPPRAISALYEAR= createAsyncThunk(
  "getPdfsByAppraisalYear/getPdfsByAppraisalYear",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getPdfsByAppraisalYearSlice = createSlice({
  name: "getPdfsByAppraisalYearSlice",
  initialState: {
    getPdfsByAppraisalYear: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetPdfsByAppraisalYear: (state) => {
        state.getPdfsByAppraisalYear.loading = false
        state.getPdfsByAppraisalYear.error = false
        state.getPdfsByAppraisalYear.data = []
        state.getPdfsByAppraisalYear.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETPDFSBYAPPRAISALYEAR.fulfilled, (state, action) => {
      state.getPdfsByAppraisalYear = {
        ...state.getPdfsByAppraisalYear,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETPDFSBYAPPRAISALYEAR.pending, (state, action) => {
      state.getPdfsByAppraisalYear = {
        ...state.getPdfsByAppraisalYear,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETPDFSBYAPPRAISALYEAR.rejected, (state, action) => {
      state.getPdfsByAppraisalYear = {
        ...state.getPdfsByAppraisalYear,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getPdfsByAppraisalYearAction = {
    GETPDFSBYAPPRAISALYEAR,
};

export { getPdfsByAppraisalYearAction };
export default getPdfsByAppraisalYearSlice.reducer;
export const {setInitialStateOfgetPdfsByAppraisalYear} = getPdfsByAppraisalYearSlice.actions
